import * as React from 'react';

import { useAppSelector } from 'flex/utils';

import AdminContents from './AdminContents';
import ControlContents from './ControlContents';

type Props = {
    tabActiveKey: string
    hasTouchScreen: boolean
};

const Classes: React.FC<Props> = ({
    tabActiveKey,
    hasTouchScreen,
}) => {
    const isControllableUser = useAppSelector(state => state.isControllableUser.payload);

    return isControllableUser ?
        <ControlContents tabActiveKey={tabActiveKey}/> :
        <AdminContents hasTouchScreen={hasTouchScreen} tabActiveKey={tabActiveKey} />;
};

export default Classes;
